module.exports = __webpack_public_path__ + "static/media/error.72361eb0.png";